/**
 * Validates and normalizes a slug from route parameters by fetching the corresponding item from the store.
 *
 * @param {Function} store The Pinia store constructor function
 * @param {string} name The route name for generating the redirect path
 * @param {Function} useLocalePath The i18n localePath composable for generating localized paths
 * @param {Object} to The target route object from Nuxt navigation
 * @param {string} to.params.slug The slug parameter from the route
 * @param {string} [populate] Optional query string for populating relations
 * @param {string} [filters] Optional query string for filtering items
 *
 * @returns {Promise<string|undefined>} Returns a redirect path if the slug needs normalization.
 */
const useCheckSlug = async function (store, name, useLocalePath, to, populate = undefined, filters = undefined) {
  const slug = to.params.slug
  const locale = useNuxtApp().$i18n.locale
  const itemsStore = store()
  const localePath = useLocalePath()

  await itemsStore.fetchOneBySlug(slug, locale.value, populate, filters)

  if (slug !== itemsStore.item.slug) {
    return localePath({ name, params: { slug: itemsStore.item.slug } })
  }
}

export default useCheckSlug
